import axios from "axios";
import { Dispatch } from "redux";
import { axiosConfig } from "../../config/index";
import {
    REQUEST_ADDED,
    REQUEST_FETCHED,
    REQUEST_EDITED,
    SET_REQUEST,
    REQUEST_DELETED,
    APPROVE_REQUEST,
    REJECT_REQUEST,
    APPROVE_LOADING,
    REJECTED,
    NEW_REQUESTS_COUNT,
    ASSIGNEE_EMPLOYEE,
    EMPLOYEE_ASSIGNED,
    REQUEST_DIACTIVATED
} from "../types";
import { setServerErrors } from "./common";

/**
 * Submits a new access card request with form data (handling attachments).
 */
export const addRequest = (requestinfo: any) => (dispatch: any) => {
    const addrequestURL = `/api/requests/addrequest`;
    const { alloweddoor, allowedsite } = requestinfo;

    const newRequestData = new FormData();
    newRequestData.append("requester", requestinfo.requestername);
    newRequestData.append("requestername", requestinfo.requestername);
    allowedsite.length > 0 && newRequestData.append("allowedsite", allowedsite.join(","));
    alloweddoor.length > 0 && newRequestData.append("alloweddoor", alloweddoor.join(","));
    newRequestData.append("requesttype", requestinfo.requesttype);
    newRequestData.append("requesterLocation", requestinfo.requesterLocation || "");
    newRequestData.append("startdate", requestinfo.startdate);
    newRequestData.append("requestDuration", requestinfo.requestDuration);
    newRequestData.append("division", requestinfo.division);
    newRequestData.append("department", requestinfo.department);
    newRequestData.append("section", requestinfo.section);
    requestinfo.reciept_attachment && newRequestData.append("reciept_attachment", requestinfo.reciept_attachment);

    return new Promise((resolve, reject) => {
        axios.post(addrequestURL, newRequestData, axiosConfig).then((res) => {
            dispatch({ type: REQUEST_ADDED, addedrequest: res.data });
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            dispatch(setServerErrors(err.response.data));
            reject(err.response.data);
        });
    });
};

/**
 * Fetches all access requests related to the currently logged in user.
 */
export const getAllRequests = () => (dispatch: any) => {
    const oracleId = sessionStorage.getItem("loggedinUser");
    axios.get(`/api/requests/getallrequest/${oracleId}`, axiosConfig).then((res) => {
        dispatch({ type: REQUEST_FETCHED, requestData: res.data });
    }).catch((err) => {
        console.error(err);
    });
};

/**
 * Fetches the report requests.
 */
export const getReport = () => (dispatch: any) => {
    axios.get(`/api/requests/getreport`, axiosConfig).then((res) => {
        dispatch({ type: REQUEST_FETCHED, requestData: res.data });
    }).catch((err) => {
        console.error(err);
    });
};

/**
 * Updates an existing request.
 */
export const editRequest = (requestId: any, editedrequestData: any) => (dispatch: any) => {
    const { alloweddoor, allowedsite } = editedrequestData;
    const formData = new FormData();
    formData.append("requestername", editedrequestData.requestername || "");
    allowedsite && allowedsite.length > 0 && formData.append("allowedsite", allowedsite.join(","));
    alloweddoor && alloweddoor.length > 0 && formData.append("alloweddoor", alloweddoor.join(","));
    formData.append("requesttype", editedrequestData.requesttype || "");
    formData.append("startdate", editedrequestData.startdate || "");
    formData.append("requestDuration", editedrequestData.requestDuration || "");
    if (editedrequestData.reciept_attachment) {
        formData.append("reciept_attachment", editedrequestData.reciept_attachment);
    }

    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/updaterequest/${requestId}`, formData, axiosConfig).then((res) => {
            dispatch({ type: REQUEST_EDITED });
            dispatch(getAllRequests());
            resolve(res.data);
        }).catch((err) => {
            console.error(err);
            reject(err?.response?.data || err);
        });
    });
};

/**
 * Sets a single request in global state.
 */
export const setRequest = (singleRequst: any) => {
    return { type: SET_REQUEST, singleRequst };
};

/**
 * Fetches new requests count.
 */
export const getNewRequestCount = () => (dispatch: any) => {
    axios.get(`/api/requests/requestType/count`, axiosConfig).then((res) => {
        dispatch({ type: NEW_REQUESTS_COUNT, newRequestCount: res.data });
    }).catch((err) => {
        console.error(err);
    });
};

/**
 * Deletes/archives a request.
 */
export const withdrawRequest = (requestId: any, oracleId: any) => (dispatch: any) => {
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/withdraw/${requestId}`, { oracleId }, axiosConfig)
            .then((res) => {
                // Optionally dispatch a specific action type if needed
                dispatch({ type: REQUEST_DELETED }); // reuse deleted action for UI refresh
                dispatch(getAllRequests());
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                reject(err?.response?.data || err);
            });
    });
};

// Permanently delete a request (admin or permitted user)
export const deleteRequest = (requestId: any) => (dispatch: any) => {
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/deleterequest/${requestId}`, {}, axiosConfig)
            .then((res) => {
                dispatch({ type: REQUEST_DELETED });
                dispatch(getAllRequests());
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                reject(err?.response?.data || err);
            });
    });
};


/**
 * Deactivates an access request.
 */
export const deactivateRequest = (requestId: any) => (dispatch: any) => {
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/deactivateRequest/${requestId}`, axiosConfig).then((res) => {
            dispatch({ type: REQUEST_DIACTIVATED });
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            console.error(err);
            reject(err);
        });
    });
};

/**
 * Approves a request at the current stage.
 */
export const approveRequest = (requestId: string, assignedActivatorId?: string, physicalCardId?: string) => (dispatch: any, getState: any) => {
    const { _id: userId } = getState().auth.user;
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/approve/${requestId}/${userId}`, { assignedActivatorId, physicalCardId }, axiosConfig).then((res) => {
            dispatch({ type: APPROVE_REQUEST, approvedRequest: res.data, approveLoading: true });
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            reject(err?.response?.data || err);
        });
    });
};

/**
 * Claims a pending request.
 */
export const claimRequest = (requestId: string) => (dispatch: any, getState: any) => {
    const { _id: userId } = getState().auth.user;
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/claim/${requestId}/${userId}`, {}, axiosConfig).then((res) => {
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            reject(err?.response?.data || err);
        });
    });
};

export const setApproveLoading = (approveLoading: boolean) => ({ type: APPROVE_LOADING, approveLoading });

/**
 * Rejects a request with a reason.
 */
export const rejectRequest = (requestId: string, remark: string) => (dispatch: any, getState: any) => {
    const { _id: userId } = getState().auth.user;
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/reject/${requestId}/${userId}`, { rejectionReason: remark }, axiosConfig).then((res) => {
            dispatch({ type: REJECT_REQUEST, rejectedRequest: res.data });
            setRejected(true);
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            console.error(err);
            reject(err?.response?.data || err);
        });
    });
};

export const setRejected = (rejected: boolean) => {
    return { type: REJECTED, rejected };
};

/**
 * Fetches assignee employees.
 */
export const getAssigneeEmployee = () => (dispatch: any) => {
    const userId = sessionStorage.getItem("loggedinUser");
    axios.get(`/api/requests/assigneeEmployees/${userId}`, axiosConfig).then((res) => {
        dispatch({ type: ASSIGNEE_EMPLOYEE, assigneeEmployee: res.data });
    }).catch((err) => {
        console.error(err);
    });
};

/**
 * Assigns staffs to a request.
 */
export const assignStaffs = (requestId: any, assigneeId: any) => (dispatch: Dispatch) => {
    return axios.put(`/api/requests/assign/${requestId}`, {
        assigneeId
    }, axiosConfig).then((res) => {
        dispatch({ type: EMPLOYEE_ASSIGNED, assignedEmployee: res.data });
    }).catch((err) => {
        console.error(err);
    });
};

/**
 * Assigns a supervisor to a request.
 */
export const assignSupervisor = (requestId: any, assigneeId: any) => (dispatch: any) => {
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/assignSupervisor/${requestId}`, {
            assigneeId
        }, axiosConfig).then((res) => {
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            console.error(err);
            reject(err);
        });
    });
};

/**
 * Fetches card activators.
 */
export const getActivators = () => (dispatch: any) => {
    axios.get(`/api/auth/activators`, axiosConfig).then((res) => {
        dispatch({ type: ASSIGNEE_EMPLOYEE, assigneeEmployee: res.data });
    }).catch((err) => {
        console.error(err);
    });
};

/**
 * Hides a list of requests for a user.
 */
export const hideRequests = (requestIds: string[], oracleId: string) => (dispatch: any) => {
    return new Promise((resolve, reject) => {
        axios.put(`/api/requests/hideRequests`, { requestIds, oracleId }, axiosConfig).then((res) => {
            dispatch(getAllRequests());
            resolve(true);
        }).catch((err) => {
            console.error("Hide error:", err);
            reject(err);
        });
    });
};
